/* kg ↔ lbs unit toggle for athlete stat rows.
   - Reads the original kg value once from each .athletes__stat-value and
     stashes it on the element so toggles are lossless.
   - Conversion uses 1 kg = 2.20462 lb. Precision mirrors the source value:
     if the source had a decimal ("925,5"), the converted value also keeps
     one decimal; integers stay integers.
   - Numbers are parsed and re-rendered in German format (comma decimal,
     no thousands separator) to match the source styling.
   - The user choice is persisted in localStorage so navigating between
     pages keeps the same unit. */
(() => {
  const STORAGE_KEY = 'azan-unit-preference';
  const KG_TO_LBS = 2.20462;

  const parseGerman = (str) => {
    if (!str) return NaN;
    const cleaned = String(str).replace(/\s/g, '').replace(',', '.');
    return parseFloat(cleaned);
  };

  const formatGerman = (num, decimals) => num.toFixed(decimals).replace('.', ',');

  const ensureStashed = (valueEl) => {
    if (valueEl.dataset.azanUnitOriginalNumber) return true;
    const numEl = valueEl.querySelector('.athletes__stat-number');
    const unitEl = valueEl.querySelector('.athletes__stat-unit');
    if (!numEl || !unitEl) return false;
    const unit = unitEl.textContent.trim().toLowerCase();
    if (unit !== 'kg') return false;
    valueEl.dataset.azanUnitOriginalNumber = numEl.textContent.trim();
    valueEl.dataset.azanUnitOriginalUnit = unitEl.textContent.trim();
    return true;
  };

  const applyUnit = (unit) => {
    document.querySelectorAll('.athletes__stat-value').forEach((valueEl) => {
      if (!ensureStashed(valueEl)) return;
      const numEl = valueEl.querySelector('.athletes__stat-number');
      const unitEl = valueEl.querySelector('.athletes__stat-unit');
      const originalNumber = valueEl.dataset.azanUnitOriginalNumber;
      const originalUnit = valueEl.dataset.azanUnitOriginalUnit;
      if (unit === 'lbs') {
        const kg = parseGerman(originalNumber);
        if (isNaN(kg)) return;
        const decimals = originalNumber.includes(',') ? 1 : 0;
        numEl.textContent = formatGerman(kg * KG_TO_LBS, decimals);
        unitEl.textContent = 'lbs';
        valueEl.classList.add('is-lbs');
      } else {
        numEl.textContent = originalNumber;
        unitEl.textContent = originalUnit;
        valueEl.classList.remove('is-lbs');
      }
    });

    document.querySelectorAll('azan-unit-toggle [data-azan-unit]').forEach((btn) => {
      const isActive = btn.dataset.azanUnit === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const readSaved = () => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      return v === 'lbs' ? 'lbs' : 'kg';
    } catch (e) {
      return 'kg';
    }
  };

  const writeSaved = (unit) => {
    try { localStorage.setItem(STORAGE_KEY, unit); } catch (e) { /* ignore */ }
  };

  const wireToggle = () => {
    document.querySelectorAll('azan-unit-toggle').forEach((toggle) => {
      if (toggle.dataset.azanWired === '1') return;
      toggle.dataset.azanWired = '1';
      toggle.querySelectorAll('[data-azan-unit]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const unit = btn.dataset.azanUnit === 'lbs' ? 'lbs' : 'kg';
          writeSaved(unit);
          applyUnit(unit);
        });
      });
    });
  };

  const init = () => {
    wireToggle();
    applyUnit(readSaved());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor reload + AJAX-injected sections. */
  document.addEventListener('shopify:section:load', init);
})();
